import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './MyPlanInfoItem.Styles';

const MyPlanInfoItem = ({
  theme = LightThemeColors,

  label,
  labelStyle,
  labelAccessibilityLabel,
  value,
  valueStyle,
  valueAccessibilityLabel,

  containerStyle,
}) => {
  return (
    <View style={[styles.containerStyle, containerStyle]}>
      <VFText
        i18nKey={label}
        style={[styles.labelStyle, labelStyle]}
        testKey={labelAccessibilityLabel}
      />
      <View style={styles.valueViewStyle}>
        <VFText
          i18nKey={value}
          style={[styles.valueStyle, valueStyle]}
          testKey={valueAccessibilityLabel}
        />
      </View>
    </View>
  );
};

MyPlanInfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  labelStyle: TextPropTypes.style,
  labelAccessibilityLabel: PropTypes.string,
  value: PropTypes.string.isRequired,
  valueStyle: TextPropTypes.style,
  valueAccessibilityLabel: PropTypes.string,
  containerStyle: ViewPropTypes.style,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};
export default withTheme(MyPlanInfoItem);
